

import { Component, Vue } from 'vue-property-decorator'
import { DOTCMS_CONTENT_ID } from '../../const'
import { DotCMSService } from '../../services'

	@Component({
	  name: 'Privacy'
	})
export default class Privacy extends Vue {
	privacyPolicy:string[] = DOTCMS_CONTENT_ID.PRIVACY_POLICY
	content:any = {}

	mounted () {
	  DOTCMS_CONTENT_ID.PRIVACY_POLICY.forEach(id => DotCMSService.getContentById(id, 1).then((response) => {
	    if (response.data && response.data.contentlets.length > 0) {
	      const id = response.data.contentlets[0].identifier
	      this.content[id] = response.data.contentlets[0]
	      this.$forceUpdate()
	    }
	  }))
	}

	navToCookiePolicy () {
	  this.$emit('openModal', 'cookie-policy')
	}
}
